import { snakeCase } from "lodash-es";

export function humanize(input) {
  return snakeCase(input).split("_").join(" ");
}
